// Fallback header sticky
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".shopify-section-group-header-group.section-header");
  window.addEventListener("scroll", function () {
    if (window.scrollY > 30) {
      header.classList.add("shopify-section-header-sticky");
    } else {
      header.classList.remove("shopify-section-header-sticky");
    }
  });
});


// collection list js start//
function initCatagorySlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-initialized')) return;

  const splide = new Splide(slider, {
  type: 'loop',
  perPage: 4,
  perMove: 1,
  gap: '30px',
  pagination: false,
  arrows: true,
  drag: true,

  breakpoints: {
    1270: {
      perPage: 3,
      gap: '15px',
    },

    989: {
      perPage: 2,
      gap: '15px',
    },

    575: {
      perPage: 1,
      perMove: 1,
      gap: '10px',
    },
     359: {
      perPage: 1,
      perMove: 1,
    },
  },
});

splide.mount();

  slider.classList.add('splide--featured-initialized');
}

function autoInitCatagorySliders(scope = document) {
  scope.querySelectorAll('.catagories-splide').forEach((slider) => {
    initCatagorySlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitCatagorySliders());
document.addEventListener('shopify:section:load', (event) => autoInitCatagorySliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitCatagorySliders(event.target));

// collection list js end//

// featured collection  js start//

// Featured Product Slider JS Start //

function initFeaturedProductSlider(slider) {
  if (!slider) return;
  if (slider.classList.contains('splide--featured-product-initialized')) return;

  const splide = new Splide(slider, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '30px',
    pagination: false,
    arrows: true,
    drag: true,
    breakpoints: {
      1600: { perPage: 4 },
      1024: { perPage: 3, gap: '15px' },
      768: { perPage: 2 },
      575: {
        perPage: 1,
        perMove: 1,
        padding: { left: '0px', right: '0px' }
      },
    },
  });

  splide.mount();

  slider.classList.add('splide--featured-product-initialized');
}

function autoInitFeaturedProductSliders(scope = document) {
  scope.querySelectorAll('.featured-product-splide').forEach((slider) => {
    initFeaturedProductSlider(slider);
  });
}

document.addEventListener('DOMContentLoaded', () => autoInitFeaturedProductSliders());
document.addEventListener('shopify:section:load', (event) => autoInitFeaturedProductSliders(event.target));
document.addEventListener('shopify:section:select', (event) => autoInitFeaturedProductSliders(event.target));

// Featured Product Slider JS End //

// featured collection  js end//



